import { Button, type ButtonProps } from "antd";
import clsx from "clsx";
import "./ActionButton.scss";

export type ActionButtonProps = ButtonProps;

export const ActionButton = ({
  className,
  type = "default",
  ...props
}: ActionButtonProps) => {
  return (
    <Button
      type={type}
      className={clsx("tableActionButton", className)}
      {...props}
    />
  );
};
